import React from 'react';
import { array, string, bool } from 'prop-types';

// Import components
import { NavCategoryList, NavDropdown } from 'components/elements';
import { VodSectionButton } from 'components/views/vod/components/buttons/VodSectionButton';

// Import styles
import {
	SectionHeaderStyled,
	Wrapper,
	Box,
	HeadingFirstStyled
} from './styles';

const SectionHeader = ({
	path,
	showLinks = true,
	showlinkToAll = true,
	navLinks,
	title,
	linkToAll,
	sectionId = ''
}) => (
	<SectionHeaderStyled>
		<Wrapper>
			<Box>
				<HeadingFirstStyled showlinkToAll={showlinkToAll}>
					{title}
				</HeadingFirstStyled>
				{showLinks && <NavCategoryList path={path} links={navLinks} />}
				{showLinks && <NavDropdown path={path} links={navLinks} />}
			</Box>
			{showlinkToAll && (
				<VodSectionButton
					sectionId={sectionId}
					sectionTitle={title}
					redirectPath={linkToAll}
					addBottomMargin
				/>
			)}
		</Wrapper>
	</SectionHeaderStyled>
);

SectionHeader.propTypes = {
	title: string.isRequired,
	links: array,
	linkToAll: string,
	showLink: bool,
	showlinkToAll: bool,
	path: string,
	sectionId: string
};

export default SectionHeader;
